<template>
  <div class="vx-card p-6">
    <div class="vx-row">
      <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
        <label class="font-medium text-base">Nguồn</label>
        <v-select class="" v-model="selectedSource" :clearable="false"
                  :options="sourcesOptions" :reduce="option => option.value">
          <span slot="no-options"> {{ $t('emptyList') }} </span>
        </v-select>
      </div>
      <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full sm:mt-0 mt-4">
        <label class="font-medium text-base">Ngày bắt đầu</label>
        <flat-pickr v-model="dateRange.startDate" :config="dateConfig" placeholder="DD/MM/YYYY" class="w-full"
                    @input="dateRangePicker"/>
      </div>
      <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full md:mt-0 mt-4">
        <label class="font-medium text-base">Ngày kết thúc</label>
        <flat-pickr v-model="dateRange.endDate" :config="dateConfig" placeholder="DD/MM/YYYY" class="w-full"
                    @input="dateRangePicker"/>
      </div>
      <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full lg:mt-0 md:mt-4 mt-4">
        <label class="font-medium text-base">Tìm kiếm</label>
        <vs-input class="w-full" v-model="keySearch" @keypress.enter="filter"
                  placeholder="Tìm kiếm theo tiêu đề ...">
        </vs-input>
      </div>
<!--      <div class="vx-col lg:w-1/12 md:w-1/6 sm:w-1/4 w-1/2 lg:mt-4 md:mt-4 mt-4">-->
<!--        <label class="font-medium text-base flex gap-1">Ngày-->
<!--          <vx-tooltip text="Số ngày trước/sau ngày xuất bản" position="top">-->
<!--            <feather-icon icon-pack="feather" icon="HelpCircleIcon" svg-classes="w-4 h-4"-->
<!--                          class="hover:text-primary"></feather-icon>-->
<!--          </vx-tooltip>-->
<!--        </label>-->
<!--        <vs-input class="w-full" v-model="dateStat"-->
<!--                  placeholder="Nhập ngày ..." type="number" @keydown.enter="filter">-->
<!--        </vs-input>-->
<!--      </div>-->
      <div class="vx-col lg:w-1/4 md:w-1/6 sm:w-1/2 w-1/2 mt-10">
        <div class="flex gap-3">
          <vx-tooltip class="" text="Tìm kiếm" position="top">
            <vs-button class="" color="primary" iconPack="feather" icon="icon-search"
                       @click="filter">
            </vs-button>
          </vx-tooltip>
          <vx-tooltip class="position-icon" text="Xuất Excel" position="top">
            <vs-button color="primary" iconPack="feather" icon="icon-download-cloud" type="border"
                       @click="exportExcel">
            </vs-button>
          </vx-tooltip>
        </div>
      </div>
    </div>

    <div class="spread-table mt-6" style="height: 60vh">
      <ag-grid-vue
        style="height: 100%; width: 100%"
        ref="agGridTable"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="dataTableArticle"
        :localeText="{noRowsToShow: 'Không có dữ liệu'}"
        :onGridReady="onGridReady"
        tooltipShowDelay="0"
        tooltipHideDelay="5000"
        :tooltipMouseTrack="true"
        :autoSizeStrategy="autoSizeStrategy">
      </ag-grid-vue>
    </div>
    <div class="vx-row mt-6" v-if="dataTableArticle.length > 0">
      <div class="vx-col md:w-1/2 w-full">
        <div class="vx-row">
          <span class="vx-col flex items-center">Số phần tử / trang:</span>
          <vs-dropdown vs-trigger-click class="cursor-pointer m-0">
            <div class="p-4 border border-solid border-2 d-theme-border-grey-light rounded-full vx-col">
                <span class="mr-2">
                    {{
                    dataTableArticle.length - currentPage * pageSize > 0 ? currentPage * pageSize : dataTableArticle.length
                  }} /
                    {{ totalElements }}
                </span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="changePageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="changePageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="changePageSize(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="changePageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full ml-auto">
        <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage" max="6"></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>

// import Datepicker from 'vuejs-datepicker';
// import * as lang from 'vuejs-datepicker/src/locale';
import moment from 'moment';
import {AgGridVue} from 'ag-grid-vue';
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import LinkCellRenderer from './cell-renderer/LinkCellRenderer';
import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Vietnamese} from 'flatpickr/dist/l10n/vn.js';
import authConfig from "../../../../auth_config.json";
import vSelect from 'vue-select';

export default {
  name: "ArticleSpreadTable",
  components: {
    // Datepicker,
    AgGridVue,
    LinkCellRenderer,
    FlatPickr,
    vSelect
  },
  data() {
    return {
      pageNumber: 1,
      pageSize: 20,
      dateStat: 7,
      totalPages: 0,
      currentPage: 1,
      totalElements: 0,
      dataTableArticle: [],
      dateRange: {
        startDate: new Date(new Date(new Date().setDate(new Date().getDate() - 7)).setHours(0, 0, 0, 0)),
        endDate: new Date()
      },
      type: "0%-20%,20%-40%,40%-60%,60%-80%,80%-100%",

      columnDefs: [
        {
          headerName: 'STT',
          field: 'Stt',
          maxWidth: 100,
        },
        {
          headerName: 'Tiêu đề bài báo',
          field: 'Title',
          cellRenderer: 'LinkCellRenderer',
          tooltipField: 'Title',
        },
        {
          headerName: 'Ngày xuất bản',
          field: 'PublishDate',
          maxWidth: 200
        },
        {
          headerName: 'Nguồn',
          field: 'SourceName',
          tooltipField: 'SourceName',
          maxWidth: 200
        },
        {
          headerName: '0%-20%',
          field: 'Type_0',
          cellStyle: {'color': '#008FFB', 'font-weight': 'bold'},
          maxWidth: 120
        },
        {
          headerName: '20%-40%',
          field: 'Type_1',
          cellStyle: {'color': '#00E396', 'font-weight': 'bold'},
          maxWidth: 120
        },
        {
          headerName: '4%-60%',
          field: 'Type_2',
          cellStyle: {'color': '#FEB019', 'font-weight': 'bold'},
          maxWidth: 120
        },
        {
          headerName: '60%-80%',
          field: 'Type_3',
          cellStyle: {'color': '#FF4560', 'font-weight': 'bold'},
          maxWidth: 120
        },
        {
          headerName: '80%-100%',
          field: 'Type_4',
          cellStyle: {'color': '#775DD0', 'font-weight': 'bold'},
          maxWidth: 120
        },
      ],
      gridApi: null,
      columnApi: null,
      defaultColDef: {
        flex: 1,
      },
      // AgGrid
      gridOptions: {
        domLayout: "normal"
      },
      autoSizeStrategy: 'fitGridWidth',
      dateConfig: {
        dateFormat: 'd/m/Y',
        allowInput: true,
        locale: Vietnamese,
      },
      sourcesOptions: [],
      selectedSource: 'null',
      keySearch: null,
    }
  },

  async created() {
    await this.getSources()
    this.getArticleSpread()
  },

  methods: {
    getArticleSpread() {
      let payload = {
        Type: '0%-20%, 20%-40%, 40%-60%, 60%-80%, 80%-100%',
        FromDate: moment(this.dateRange.startDate, 'DD/MM/YYYY').format("YYYY-MM-DD"),
        // FromDate: '2024-01-01',
        ToDate: moment(this.dateRange.endDate, 'DD/MM/YYYY').format("YYYY-MM-DD"),
      }

      let url = `/apiv2/statistic/get_ids?page=${this.pageNumber}&limit=${this.pageSize}`
      if (this.keySearch) url = url + `&text=${this.keySearch}`
      if (this.selectedSource !== 'null') url = url + `&src=${this.selectedSource}`

      this.$vs.loading()
      this.$spread.post(url, payload).then(res => {
        this.dataTableArticle = res.data.news ? res.data.news : []
        if (this.dataTableArticle.length > 0) {
          this.dataTableArticle.forEach(el => {
            el.Stt = (this.pageNumber - 1) * this.pageSize + this.dataTableArticle.indexOf(el) + 1
            el['Type_0'] = el.Statistic[0].Total
            el['Type_1'] = el.Statistic[1].Total
            el['Type_2'] = el.Statistic[2].Total
            el['Type_3'] = el.Statistic[3].Total
            el['Type_4'] = el.Statistic[4].Total
          })
        }
        this.totalElements = res.data.Total
        this.totalPages = res.data.TotalPage
        this.$vs.loading.close()
      }).catch((err) => {
        this.$vs.loading.close()
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
    },

    dateRangePicker() {
      // let date = this.dateRange
      // date.startDate = moment(this.dateRange.startDate, 'DD/MM/YYYY')
      // date.endDate = moment(this.dateRange.endDate, 'DD/MM/YYYY')
      // if (new Date(this.dateRange.startDate).getTime() > new Date(this.dateRange.endDate).getTime()) {
      //   return this.$vs.notify({
      //     text: 'Ngày bắt đầu phải nhỏ hơn ngày kết thúc!',
      //     iconPack: 'feather',
      //     icon: 'icon-alert-circle',
      //     color: 'danger'
      //   });
      // }
    },

    changePageSize(number) {
      this.pageSize = number
      this.pageNumber = 1
      this.currentPage = 1
      this.getArticleSpread()
    },

    loadPage: function (currentPage) {
      if (this.pageNumber !== currentPage) {
        this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) : 0
        this.getArticleSpread()
      }
    },

    onGridReady() {
      if (this.$store.state.windowWidth > 1024) {
        this.gridApi.sizeColumnsToFit();
      }
    },

    filter() {
      this.pageNumber = 1
      this.currentPage = 1
      this.getArticleSpread()
    },

    exportExcel() {
      let from_date = moment(this.dateRange.startDate, 'DD/MM/YYYY').format("YYYY-MM-DD"),
        to_date = moment(this.dateRange.endDate,'DD/MM/YYYY').format("YYYY-MM-DD"),
        type = '0%-20%, 20%-40%, 40%-60%, 60%-80%, 80%-100%'
      let url = `/apiv2/export/statistic/get_ids?type_stat=${type}&page=${this.pageNumber}&limit=${this.pageSize}&from_date=${from_date}&to_date=${to_date}`
      if (this.keySearch) url = url + `&text=${this.keySearch}`
      if (this.selectedSource !== 'null') url = url + `&src=${this.selectedSource}`

      window.open(authConfig.spreadDomain + url, "_blank")
    },

    getSources() {
      return new Promise((resolve, reject) => {
        this.$vs.loading()
        this.$spread.get('/apiv2/get_sources').then(res => {
          if (res.data.Sources.length > 0) {
            this.sourcesOptions = res.data.Sources.map(el => {
              return {
                value: el,
                label: el
              }
            })
          } else {
            this.sourcesOptions = []
          }
          this.sourcesOptions.unshift({value: 'null', label: 'Tất cả'})
          resolve(res)
          this.$vs.loading.close()
        }).catch((err) => {
          reject(err)
          this.$vs.loading.close()
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      })
    },
  },
}
</script>

<style lang="scss">
.spread-table .ag-theme-material .ag-header-row {
  background-color: rgb(241 245 249);
}

.ag-watermark {
  display: none !important;
}
</style>
